import axios from 'axios';

class MondayServerApi {
  constructor() {
    this.client = axios.create({
      baseURL: 'https://api.monday.com/v2',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${process.env.REACT_APP_MONDAY_CLIENT_ID}`,
        'API-Version': '2024-01'
      }
    });
  }
  // ... rest of the code
}

export default new MondayServerApi(); 